/* eslint-disable */
import { PluginContainerData, Oembed } from './common';
const baseEmbedData = {};
export const EmbedData = {
    fromJSON(object) {
        const message = Object.assign({}, baseEmbedData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.oembed =
            object.oembed !== undefined && object.oembed !== null
                ? Oembed.fromJSON(object.oembed)
                : undefined;
        message.src = object.src !== undefined && object.src !== null ? String(object.src) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.oembed !== undefined &&
            (obj.oembed = message.oembed ? Oembed.toJSON(message.oembed) : undefined);
        message.src !== undefined && (obj.src = message.src);
        return obj;
    },
};
//# sourceMappingURL=plugin_embed.js.map